import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
  produce3s4oh9balbl5b as produce,
} from '../../channels/Produce.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emitAll233y0vrwmloef as emitAll } from '../Channels.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope5mg03ltqqkp0 as coroutineScope,
} from '../../CoroutineScope.mjs';
import { BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineStart_ATOMIC_getInstance1xsp76269lswt as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { SendingCollector33jb503i6hglm as SendingCollector } from './SendingCollector.mjs';
import { newCoroutineContext1x74axajiiptk as newCoroutineContext } from '../../CoroutineContext.mjs';
import { Key_instancesrycfl6s632h as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { NopCollector2h4omm21qc7hq as NopCollector } from './NopCollector.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from '../../internal/ThreadContext.mjs';
import { startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
function ChannelFlow$_get_collectToFun_$slambda_j53z2e() {
  if (ChannelFlow$_get_collectToFun_$slambda_j53z2eClass === VOID) {
    class $ {
      constructor(this$0) {
        this.s1f_1 = this$0;
      }
      *t1f(it, $completion) {
        yield* this.s1f_1.a1d(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.t1f((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$_get_collectToFun_$slambda_j53z2eClass = $;
  }
  return ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
}
function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0) {
  var i = new (ChannelFlow$_get_collectToFun_$slambda_j53z2e())(this$0);
  var l = (it, $completion) => i.t1f(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlow$collect$slambdaClass;
function ChannelFlow$collect$slambda() {
  if (ChannelFlow$collect$slambdaClass === VOID) {
    class $ {
      constructor($collector, this$0) {
        this.u1f_1 = $collector;
        this.v1f_1 = this$0;
      }
      *w1f($this$coroutineScope, $completion) {
        yield* emitAll(this.u1f_1, this.v1f_1.i1d($this$coroutineScope), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.w1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$collect$slambdaClass = $;
  }
  return ChannelFlow$collect$slambdaClass;
}
function ChannelFlow$collect$slambda_0($collector, this$0) {
  var i = new (ChannelFlow$collect$slambda())($collector, this$0);
  var l = ($this$coroutineScope, $completion) => i.w1f($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.b1d_1 = context;
        this.c1d_1 = capacity;
        this.d1d_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      e1d() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this);
      }
      f1d() {
        return this.c1d_1 === -3 ? -2 : this.c1d_1;
      }
      g1d(context, capacity, onBufferOverflow) {
        // Inline function 'kotlinx.coroutines.assert' call
        var newContext = context.hm(this.b1d_1);
        var newCapacity;
        var newOverflow;
        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          newCapacity = capacity;
          newOverflow = onBufferOverflow;
        } else {
          var tmp;
          if (this.c1d_1 === -3) {
            tmp = capacity;
          } else if (capacity === -3) {
            tmp = this.c1d_1;
          } else if (this.c1d_1 === -2) {
            tmp = capacity;
          } else if (capacity === -2) {
            tmp = this.c1d_1;
          } else {
            // Inline function 'kotlinx.coroutines.assert' call
            // Inline function 'kotlinx.coroutines.assert' call
            var sum = this.c1d_1 + capacity | 0;
            tmp = sum >= 0 ? sum : 2147483647;
          }
          newCapacity = tmp;
          newOverflow = this.d1d_1;
        }
        if (equals(newContext, this.b1d_1) && newCapacity === this.c1d_1 && newOverflow.equals(this.d1d_1))
          return this;
        return this.z1c(newContext, newCapacity, newOverflow);
      }
      i1d(scope) {
        return produce(scope, this.b1d_1, this.f1d(), this.d1d_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.e1d());
      }
      *u1c(collector, $completion) {
        return yield* coroutineScope(ChannelFlow$collect$slambda_0(collector, this), $completion);
      }
      j1d() {
        return null;
      }
      toString() {
        var props = ArrayList().h2(4);
        var tmp0_safe_receiver = this.j1d();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.i2(tmp0_safe_receiver);
        }
        if (!(this.b1d_1 === EmptyCoroutineContext_instance)) {
          props.i2('context=' + toString(this.b1d_1));
        }
        if (!(this.c1d_1 === -3)) {
          props.i2('capacity=' + this.c1d_1);
        }
        if (!this.d1d_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.i2('onBufferOverflow=' + this.d1d_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    protoOf($).h1d = fuse$default;
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, [FusibleFlow()], [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.g1d(context, capacity, onBufferOverflow) : $super.g1d.call(this, context, capacity, onBufferOverflow);
}
var FusibleFlowClass;
function FusibleFlow() {
  if (FusibleFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FusibleFlow', VOID, VOID, VOID, [1]);
    FusibleFlowClass = $;
  }
  return FusibleFlowClass;
}
var ChannelFlowOperatorImplClass;
function ChannelFlowOperatorImpl() {
  if (ChannelFlowOperatorImplClass === VOID) {
    class $ extends ChannelFlowOperator() {
      constructor(flow, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -3 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(flow, context, capacity, onBufferOverflow);
      }
      z1c(context, capacity, onBufferOverflow) {
        return new (ChannelFlowOperatorImpl())(this.e1g_1, context, capacity, onBufferOverflow);
      }
      *f1g(collector, $completion) {
        return yield* this.e1g_1.u1c(collector, $completion);
      }
    }
    initMetadataForClass($, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
    ChannelFlowOperatorImplClass = $;
  }
  return ChannelFlowOperatorImplClass;
}
function *collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.mc();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return yield* withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this), $completion);
}
var ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
function ChannelFlowOperator$collectWithContextUndispatched$slambda() {
  if (ChannelFlowOperator$collectWithContextUndispatched$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.g1g_1 = this$0;
      }
      *h1g(it, $completion) {
        yield* this.g1g_1.f1g(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.h1g((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlowOperator$collectWithContextUndispatched$slambdaClass = $;
  }
  return ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0) {
  var i = new (ChannelFlowOperator$collectWithContextUndispatched$slambda())(this$0);
  var l = (it, $completion) => i.h1g(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowOperatorClass;
function ChannelFlowOperator() {
  if (ChannelFlowOperatorClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(flow, context, capacity, onBufferOverflow) {
        super(context, capacity, onBufferOverflow);
        this.e1g_1 = flow;
      }
      *a1d(scope, $completion) {
        return yield* this.f1g(new (SendingCollector())(scope), $completion);
      }
      *u1c(collector, $completion) {
        if (this.c1d_1 === -3) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var collectContext = $completion.mc();
          var newContext = newCoroutineContext(collectContext, this.b1d_1);
          if (equals(newContext, collectContext))
            return yield* this.f1g(collector, $completion);
          if (equals(newContext.yc(Key_instance), collectContext.yc(Key_instance)))
            return yield* /*#__NOINLINE__*/collectWithContextUndispatched(this, collector, newContext, $completion);
        }
        yield* super.u1c(collector, $completion);
        return Unit_instance;
      }
      toString() {
        return toString(this.e1g_1) + ' -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
    ChannelFlowOperatorClass = $;
  }
  return ChannelFlowOperatorClass;
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector();
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (UndispatchedContextCollector())(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function *withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    var tmp0 = block;
    var tmp2 = value;
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new (StackFrameContinuation())(uCont, newContext);
    return startCoroutineUninterceptedOrReturnGeneratorVersion(tmp0, tmp2, completion);
  };
}
var UndispatchedContextCollector$emitRef$slambdaClass;
function UndispatchedContextCollector$emitRef$slambda() {
  if (UndispatchedContextCollector$emitRef$slambdaClass === VOID) {
    class $ {
      constructor($downstream) {
        this.i1g_1 = $downstream;
      }
      *j1g(it, $completion) {
        yield* this.i1g_1.m1d(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.j1g(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UndispatchedContextCollector$emitRef$slambdaClass = $;
  }
  return UndispatchedContextCollector$emitRef$slambdaClass;
}
function UndispatchedContextCollector$emitRef$slambda_0($downstream) {
  var i = new (UndispatchedContextCollector$emitRef$slambda())($downstream);
  var l = (it, $completion) => i.j1g(it, $completion);
  l.$arity = 1;
  return l;
}
var UndispatchedContextCollectorClass;
function UndispatchedContextCollector() {
  if (UndispatchedContextCollectorClass === VOID) {
    class $ {
      constructor(downstream, emitContext) {
        this.k1g_1 = emitContext;
        this.l1g_1 = threadContextElements(this.k1g_1);
        var tmp = this;
        tmp.m1g_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream);
      }
      *m1d(value, $completion) {
        return yield* /*#__NOINLINE__*/withContextUndispatched(this.k1g_1, value, this.l1g_1, this.m1g_1, $completion);
      }
    }
    initMetadataForClass($, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector()], [1]);
    UndispatchedContextCollectorClass = $;
  }
  return UndispatchedContextCollectorClass;
}
var StackFrameContinuationClass;
function StackFrameContinuation() {
  if (StackFrameContinuationClass === VOID) {
    class $ {
      constructor(uCont, context) {
        this.n1g_1 = uCont;
        this.o1g_1 = context;
      }
      mc() {
        return this.o1g_1;
      }
      oc(result) {
        this.n1g_1.oc(result);
      }
    }
    initMetadataForClass($, 'StackFrameContinuation', VOID, VOID, [Continuation()]);
    StackFrameContinuationClass = $;
  }
  return StackFrameContinuationClass;
}
//region block: exports
export {
  fuse$default as fuse$default20ez9dp5pjoz7,
  ChannelFlowOperatorImpl as ChannelFlowOperatorImpl3gjkp847e0ebc,
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
  FusibleFlow as FusibleFlow2tgh9s2p1kryd,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
